import Config from '@lib/Config'
import Log from '@lib/Log'
import { ABConfigsStore } from '@store/ab-configs'
import { LeadgenPopupType } from '@components/LeadgenPopupFlow'


export const determineProgramType = (
  industryType: IndustryType,
  productType?: ProductType
): ProgramType => {
  switch (industryType) {
    case 'PNC':
      return 'Auto'
    case 'Disability':
      return 'Disability'
    case 'Life':
      return productType === 'Guaranteed Issue' ? 'GI' : 'Life'
    case 'Medsup':
      return productType === 'Medicare Advantage' ? 'MA' : 'MS'
    default: {
      Log.error('@lib/determineProgramType', `Program type could not be determined given a productType: '${productType}' and industryType: '${industryType}'`);
      return 'MS' // shouldn't come through this stage, but just preventing an unexpected error for TS.
    }
  }
}

export const hasProgramTypePermission = (
  industryType: IndustryType,
  productType?: ProductType
): boolean => {
  const programType = determineProgramType(industryType, productType)

  switch (programType) {
    case 'Disability':
      return Config.abConfigs.eloqua_post_disability
    case 'Life':
      return Config.abConfigs.eloqua_post_life
    case 'MS':
      return Config.abConfigs.eloqua_post_medsup
    case 'MA':
      return Config.abConfigs.eloqua_post_medadv
    case 'GI':
      return Config.abConfigs.eloqua_post_gi
    case "Auto":
      return Config.abConfigs.eloqua_post_auto
  }
}

export const getExternalAb = (showLeadgenPopupFor: LeadgenPopupType | null): string | undefined => {
  const {
    medSupQuotesFlag,
    medAdvQuotesFlag,
    lifeQuotesFlag
  } = ABConfigsStore.getQuoteConfigsSync()

  if(showLeadgenPopupFor === LeadgenPopupType.LIFE_INSURANCE) {
    return lifeQuotesFlag === 'off' ? 'no_quote_life' : 'show_quote_life';
  } else if (showLeadgenPopupFor === LeadgenPopupType.MEDSUP) {
    return medSupQuotesFlag === 'off' ? 'no_quote_medsup' : 'show_quote_medsup';
  } else if (showLeadgenPopupFor === LeadgenPopupType.MEDADV) {
    return medAdvQuotesFlag === 'off' ? 'no_quote_medadv' : 'show_quote_medadv';
  } else if (showLeadgenPopupFor === LeadgenPopupType.SCHEDULE_AEP) {
    return 'homepage_schedule_call_aep';
  }
  return undefined;
}

export const getIndustryType = (showLeadgenPopupFor: LeadgenPopupType | null): IndustryType => {
  if(showLeadgenPopupFor === LeadgenPopupType.LIFE_INSURANCE || showLeadgenPopupFor === LeadgenPopupType.GUARANTEED_ISSUE) {
    return 'Life'
  }
  if(showLeadgenPopupFor === LeadgenPopupType.DISABILITY) {
    return 'Disability'
  }
  if(showLeadgenPopupFor === LeadgenPopupType.AUTO_INSURANCE) {
    return 'PNC'
  }
  return 'Medsup'
}

export const getLeadProductType = (showLeadgenPopupFor: LeadgenPopupType | null): ProductType | undefined => {
  const { medSupQuotesFlag } = ABConfigsStore.getQuoteConfigsSync()

  if (showLeadgenPopupFor === LeadgenPopupType.GUARANTEED_ISSUE){
    return 'Guaranteed Issue';
  } else if (showLeadgenPopupFor === LeadgenPopupType.DISABILITY || showLeadgenPopupFor === LeadgenPopupType.LIFE_INSURANCE) {
    return undefined;
  } else if (showLeadgenPopupFor === LeadgenPopupType.SCHEDULE_AEP) {
    return 'Medsup';
  } else {
    const isMACompliant =
      showLeadgenPopupFor === 'MEDADV' ||
      showLeadgenPopupFor === 'PDP' ||
      showLeadgenPopupFor === 'MEDSUP' && !medSupQuotesFlag

    return isMACompliant ? 'Medicare Advantage' : undefined
  }
}
